import { useMemo } from 'react';
import { useQueryParams } from '../../../hooks/use-query-params';

export const useOrderQuantitySummary = ({
  returnAndRecipientAddresses,
}: {
  returnAndRecipientAddresses: number;
}): {
  quantity: number;
  blankEnvelopes: number;
} => {
  const queryParams = useQueryParams();
  const quantity = useMemo(() => Number(queryParams.get('qty') || 1), [queryParams]);

  const blankEnvelopes: number = useMemo(() => {
    if (returnAndRecipientAddresses === 0) return quantity;

    return quantity > 1 ? Number(quantity - returnAndRecipientAddresses) : Number(0);
  }, [quantity, returnAndRecipientAddresses]);

  return {
    quantity,
    blankEnvelopes,
  };
};
